import { useHistory } from 'react-router-dom';
import { useCallback, useContext } from 'react';
import { StudioPrintSettingsContext } from '../contexts';
import { analyticsService, getBlankStudio, isReport, navigateToReportLab, navigateToStudioView } from 'venn-utils';
import type { Subject } from 'venn-state';
import type { AnalysisViewTypeEnum } from 'venn-api';

export const useNavigateToStudio = (location: string, viewType: AnalysisViewTypeEnum) => {
  const history = useHistory();
  const { addDisclosurePage } = useContext(StudioPrintSettingsContext);

  return useCallback(
    (subjects: Subject[]) => {
      const newDocument = getBlankStudio(viewType, addDisclosurePage, subjects);

      analyticsService.creatingNewStudios({
        source: location,
        name: 'blank report',
      });

      if (isReport(viewType)) {
        navigateToReportLab(history, { newDocument });
      } else {
        navigateToStudioView(history, { newDocument });
      }
    },
    [viewType, addDisclosurePage, history, location],
  );
};
